interface InstructionContentProps {
  isDomainCaptureBlocked: boolean;
  isAutoJoin: boolean;
}

export function InstructionContent({
  isAutoJoin,
  isDomainCaptureBlocked,
}: InstructionContentProps) {
  if (isDomainCaptureBlocked) {
    return (
      <p>
        You can access Zapier from your identity provider, or contact your admin
        for an invite to join the account. Otherwise, use a different email to
        create a personal account.
      </p>
    );
  }

  return isAutoJoin ? (
    <p>
      Join your team, or use a different email to create a personal account. You
      must be assigned the Zapier app in your identity provider to access
      Zapier.
    </p>
  ) : (
    <p>
      Contact your company admin for an invite to join the account, or use a
      different email to create a personal account.
    </p>
  );
}
